import clsx, { ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

// export const stringToHex = (str: string) => {
//   let hex = '';
//   for (let i = 0; i < str.length; i += 1) {
//     hex += str.charCodeAt(i).toString(16);
//   }
//   return hex;
// };

// export const hexToString = (hex: string) => {
//   let str = '';
//   for (let i = 0; i < hex.length; i += 2) {
//     str += String.fromCharCode(parseInt(hex.substring(i, i + 2), 16));
//   }
//   return str;
// };

export const cn = (...inputs: ClassValue[]): string => {
  return twMerge(clsx(inputs));
};
